import BaseService from './BaseService';

class Auth extends BaseService {
    current() {
        return this.get('/auth/user');
    }

    signin(email, company_id, campaign_id, subject_id, redirect, scope) {
        return this.post('/auth/email/manager_signin', {
            email,
            company_id,
            campaign_id,
            subject_id,
            redirect,
            scope,
        });
    }

    emailsignin(token, scope = 'lms') {
        return this.post(`/auth/email/signin/${token}`, { scope });
    }

    /**
     * Exchange sign-in link JWT for real session token.
     * Returns real token or throws with response.data: { expired, resent, message }.
     */
    jwtExchange(token) {
        return this.post('/auth/jwt/exchange', { token });
    }

    signOutAudit(companyId, scope = 'lms') {
        return this.put(`/auth/log/signout/${companyId}`,{ scope });
    }

    switchCompanyAudit(oldCompanyId, newCompanyId, switchSource, scope = 'lms') {
        return this.put(`/auth/log/switch`, {
            newCompanyId,
            oldCompanyId,
            switchSource,
            scope
        });
    }

    checkEmail(email) {
        return this.post('/auth/checkEmail', { email });
    }

    registerTrial(data, simple) {
        return simple
            ? this.post('/trial', data)
            : this.post('/auth/manager/trial/new', data);
    }

    registerFreemium(data) {
        return this.post('/freemium/test3', data);
    }
}

export default Auth;
